import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { RequestAction } from "stores/Request/RequestAction";
import { VehicleAction } from "stores/vehicles/VehicleAction";

const mapStateToProps = (state) => {
  return {
    RequestVehicleDataList:state.RequestData.RequestVehicleDataList,
    isLoading:state.RequestData.RequestVehicleDataloading.isLoading,
    getModeldropdowndata:state.vehicleData.getModeldropdowndata,
    getVariantdropdowndata:state.vehicleData.getVariantdropdowndata,
    // HostListData:state.common.HostListData
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRequestVehicleDataAction:RequestAction.getRequestVehicleData,
      getVehicleModelData:VehicleAction.getVehicleModelData,
      getVehicleVariantData:VehicleAction.getVehicleVariantData
    //   getHostListDataAction: commonActions.getHostListData
    },
    dispatch
  );

const RequestStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default RequestStore;
